import React from "react"
import MUITooltip, {
  TooltipProps as MUITooltipProps,
} from "@mui/material/Tooltip"
import { MUIMappedTooltip } from "./mantine/Tooltip.mantine"

export type TooltipProps =
  | ({ new?: false } & MUITooltipProps)
  | ({ new: true } & MUITooltipProps)

export const Tooltip = React.forwardRef<any, TooltipProps>((props, ref) =>
  props.new ? (
    <MUIMappedTooltip {...props} ref={ref} />
  ) : (
    <MUITooltip {...props} ref={ref} />
  ),
)

Tooltip.displayName = "Tooltip"

export default Tooltip
